import React from "react";
import ReactDOM from "react-dom";
import App from './App';
import { HashRouter } from 'react-router-dom';
import { ThemeProvider } from '@material-ui/core';
import theme from './theme';
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/service-worker.js', { scope: '/' }).then(function (reg) {
    // регистрация сработала
    console.log('Registration succeeded. Scope is ' + reg.scope);
  }).catch(function (error) {
    // регистрация прошла неудачно
    console.log('Registration failed with ' + error);
  });
};
ReactDOM.render(
  <HashRouter>
    <ThemeProvider theme={theme} >
      <App />
    </ThemeProvider></HashRouter>,
  document.querySelector('#root')
);
